export default __webpack_public_path__ + "static/media/IMG_022.fb800986.jpg";